import { FilterDocumentDateCustomTypes } from 'shared/types/filter-document';

export const inferCustomRangeType = (
  start?: Date | null,
  end?: Date | null,
): FilterDocumentDateCustomTypes => {
  if (start && end) {
    return FilterDocumentDateCustomTypes.Between;
  }
  if (end) {
    return FilterDocumentDateCustomTypes.Before;
  }
  if (start) {
    return FilterDocumentDateCustomTypes.After;
  }
  // This case shouldn't happen if custom is set, but default to 'between'
  return FilterDocumentDateCustomTypes.Between;
};
